import Alpine from 'alpinejs';
import intersect from "@alpinejs/intersect";
import collapse from "@alpinejs/collapse";

Alpine.plugin(intersect);
Alpine.plugin(collapse);

import { nav } from './components/nav';
import { accordion } from "./components/accordion";
import { adjustableHeight } from "./components/adjustableheight";
import { modals } from "./components/modals";
import { programOptions } from "./components/programOptions";
import { csrfToken } from './components/csrf-token';
import trapFocus from './components/trapFocus';
import AOS from 'aos';
import Splide from '@splidejs/splide';

function inits() {
  AOS.init();
}
inits();

nav();
accordion();
modals();
programOptions();
csrfToken();
const splideElement = document.getElementsByClassName(
	'splide'
)

if (splideElement.length > 0) {
  console.log(splideElement.length)
  for ( var i = 0; i < splideElement.length; i++ ) {
    var slider = new Splide( splideElement[ i ] );
    slider.mount({adjustableHeight});
    if (slider.length === 1) {
      slider.destroy(true)
    }
  }
}

Alpine.store("global", {
	mobileMenuOpen: false,
});
Alpine.data("trapFocus", trapFocus);

Alpine.start();